"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseCouponListRequest = void 0;
var UseCouponListRequest = /** @class */ (function () {
    function UseCouponListRequest() {
    }
    return UseCouponListRequest;
}());
exports.UseCouponListRequest = UseCouponListRequest;
//# sourceMappingURL=useCouponList.request.js.map